var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgButtonIconWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23C12.134 23 9 19.866 9 16C9 12.134 12.134 9 16 9C19.866 9 23 12.134 23 16C23 19.866 19.866 23 16 23ZM16 24C18.1217 24 20.1566 23.1571 21.6569 21.6569C23.1571 20.1566 24 18.1217 24 16C24 11.5817 20.4183 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24ZM16 11.5C15.7239 11.5 15.5 11.7239 15.5 12V17.6C15.5 17.8761 15.7239 18.1 16 18.1C16.2761 18.1 16.5 17.8761 16.5 17.6V12C16.5 11.7239 16.2761 11.5 16 11.5ZM16 19.1C15.7239 19.1 15.5 19.3239 15.5 19.6C15.5 19.8761 15.7239 20.1 16 20.1C16.2761 20.1 16.5 19.8761 16.5 19.6C16.5 19.3239 16.2761 19.1 16 19.1Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgButtonIconWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ButtonIconWarning.1df04f7c70c188e4afbc93278bf229fa.svg";